export const EventName = Object.freeze({
	CloseWizard: 'booking:resource-creation-wizard:close',
	CreateBookings: 'booking:booking:create',
	DeleteBooking: 'booking:booking:delete',
	UpdateBooking: 'booking:booking:update',
});
